import { render, staticRenderFns } from "./StakingDelegatePool.vue?vue&type=template&id=6bf50b0f&scoped=true&"
import script from "./StakingDelegatePool.vue?vue&type=script&lang=js&"
export * from "./StakingDelegatePool.vue?vue&type=script&lang=js&"
import style0 from "./StakingDelegatePool.vue?vue&type=style&index=0&id=6bf50b0f&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bf50b0f",
  null
  
)

export default component.exports